/*
 * DD editorial scroll-reveal.
 *
 * Tags homepage sections below the hero with [data-dd-reveal] and flips on
 * .dd-is-revealed when they enter the viewport. The attribute is only ever
 * added by this script, so with JS disabled (or on non-index templates)
 * every section renders fully visible — motion is progressive enhancement.
 * Styles live in assets/dd-brand.css behind prefers-reduced-motion guards.
 *
 * Opt-in extensions (any template, wired by markup):
 *   [data-dd-reveal-self]   – element is promoted to [data-dd-reveal] and
 *                             observed individually.
 *   [data-dd-reveal-group]  – container is promoted to [data-dd-reveal-stagger];
 *                             its direct children cascade in with per-child
 *                             transition delays (--dd-stagger-i) when the
 *                             container intersects. Styles in dd-motion.css.
 * The promoted attributes only come from this script, preserving the
 * no-JS-fully-visible guarantee.
 */

const ddReducedMotion = !matchMedia('(prefers-reduced-motion: no-preference)').matches;

if (!ddReducedMotion) {
  const ddRevealObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dd-is-revealed');
          ddRevealObserver.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 },
  );

  const main = document.querySelector('main[data-template="index"]');

  if (main) {
    const sections = main.querySelectorAll(':scope > .shopify-section');

    // Skip the first section (hero): it is above the fold and must paint instantly.
    sections.forEach((section, index) => {
      if (index === 0) return;
      section.setAttribute('data-dd-reveal', '');
      ddRevealObserver.observe(section);
    });
  }

  // Single-element opt-in: [data-dd-reveal-self] -> [data-dd-reveal].
  document.querySelectorAll('[data-dd-reveal-self]').forEach((el) => {
    el.removeAttribute('data-dd-reveal-self');
    el.setAttribute('data-dd-reveal', '');
    ddRevealObserver.observe(el);
  });

  // Staggered-group opt-in: children cascade when the container reveals.
  document.querySelectorAll('[data-dd-reveal-group]').forEach((group) => {
    Array.from(group.children).forEach((child, index) => {
      child.style.setProperty('--dd-stagger-i', index);
    });
    group.removeAttribute('data-dd-reveal-group');
    group.setAttribute('data-dd-reveal-stagger', '');
    ddRevealObserver.observe(group);
  });
}
